'use client'

/**
 * Keeps the Sarah launcher off the hero valuation card on phones (Public Look,
 * #545 soft 5). While the hero ask card is on screen, html[data-sell-fold="1"]
 * is set and sell-landing.css hides the floating launcher below 64rem. It
 * comes back as soon as the card scrolls away. Removed on leaving /sell.
 */
import { useEffect } from 'react'

const ATTR = 'data-sell-fold'

export function SellFoldGuard() {
  useEffect(() => {
    const root = document.documentElement
    const card = document.querySelector('#sell-hero .sell-stage-ask')
    if (!card || typeof IntersectionObserver === 'undefined') return
    const io = new IntersectionObserver(
      (entries) => {
        const on = entries.some((e) => e.isIntersecting)
        if (on) root.setAttribute(ATTR, '1')
        else root.removeAttribute(ATTR)
      },
      { threshold: 0 },
    )
    io.observe(card)
    return () => {
      io.disconnect()
      root.removeAttribute(ATTR)
    }
  }, [])
  return null
}
